import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';

import { OS } from './types';

export { OS };
export default function getOS(): OS {
  if (isAndroid) {
    return OS.Android;
  }

  if (isMacOs) {
    return OS.macOS;
  }

  if (isWindows) {
    return OS.Windows;
  }

  if (isIOS) {
    return OS.iOS;
  }

  return OS.web;
}
